import { render, staticRenderFns } from "./ProspectsList.vue?vue&type=template&id=2a11826c&scoped=true"
import script from "./ProspectsList.vue?vue&type=script&lang=js"
export * from "./ProspectsList.vue?vue&type=script&lang=js"
import style0 from "./ProspectsList.vue?vue&type=style&index=0&id=2a11826c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a11826c",
  null
  
)

export default component.exports